import React,{useEffect} from "react";
import { Box, Container, Typography } from "@mui/material";
// import { useNavigate } from "react-router-dom";
import AboutUSBannerImage from "../assets/aboutus banner image.png";

import aboutImg1 from "../assets/about-image-1.png";
import aboutImg2 from "../assets/about-image-2.jpg";
import aboutImg3 from "../assets/about-image-3.jpg";
import aboutImg4 from "../assets/about-image-4.jpg";
import aboutImg5 from "../assets/about-image-5.jpg";
import aboutImg6 from "../assets/about-image-6.jpg";
import aboutImg7 from "../assets/about-image-7.jpg";



const FOREST = "#0d2b21";
const GOLD = "#c9a84c";
const MUTED = "#6b7a73";

/* ================= HERO STATS ================= */

const STATS = [
    { val: "10k+", label: "Professionals Served" },
    { val: "500+", label: "Products Available" },
    { val: "15+", label: "Global Brand Partners" },
    { val: "24/7", label: "Technical Support" },
];

/* ================= REUSABLE SECTION WRAPPER ================= */
const Section = ({ reverse, title, subtitle, text, img }) => {
    return (
        <Box sx={{ borderTop: "1px solid #eee", py: { xs: 6, md: 8 } }}>
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: {
                            xs: "column",
                            md: reverse ? "row-reverse" : "row",
                        },
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 6,
                    }}
                >
                    {/* TEXT */}
                    <Box sx={{ flex: 1 }}>
                        <Box sx={{ width: 40, height: 2, background: GOLD, mb: 2 }} />

                        <Typography
                            sx={{
                                color: GOLD,
                                fontSize: "11px",
                                letterSpacing: "2px",
                                textTransform: "uppercase",
                                mb: 1.5,
                            }}
                        >
                            {subtitle}
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: { xs: "1.4rem", md: "1.8rem" },
                                fontWeight: 700,
                                color: FOREST,
                                mb: 2,
                                lineHeight: 1.2,
                            }}
                        >
                            {title}
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: "15px",
                                color: MUTED,
                                lineHeight: 1.9,
                                maxWidth: 650,
                            }}
                        >
                            {text}
                        </Typography>
                    </Box>

                    {/* IMAGE (SMALLER + CONTROLLED) */}
                    <Box
                        component="img"
                        src={img}
                        alt={title}
                        sx={{
                            width: { xs: "100%", sm: "65%", md: "420px" },
                            height: "280px",
                            objectFit: "cover",
                            borderRadius: 3,
                            boxShadow: "0 20px 50px rgba(0,0,0,0.12)",
                            flexShrink: 0,
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};

/* ================= MAIN COMPONENT ================= */
export default function AboutUs() {
      useEffect(() => {

        document.title =
            "About Us | Tecniqa";

    }, []);
    return (
        <>
            <style>{`

@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,700;0,800;1,700&family=DM+Sans:wght@300;400;500;600;700&display=swap');

.au-root{
  --brand:#8BAE66;
--brand-dark:#628141;

  --ff-display:'Barlow Condensed',sans-serif;
  --ff-body:'DM Sans',sans-serif;

  font-family:var(--ff-body);

  overflow-x:hidden;
}

/* HERO */

.au-hero{
  position:relative;

  min-height:600px;

  overflow:hidden;

  display:flex;
  align-items:center;
  justify-content:center;
}

.au-hero-img{
  position:absolute;
  inset:0;

  width:100%;
  height:100%;

  object-fit:cover;

  transform:scale(1.06);

  filter:blur(2px) brightness(.72);

  animation:auHeroZoom 16s linear infinite alternate;
}

@keyframes auHeroZoom{

  from{
    transform:scale(1.06);
  }

  to{
    transform:scale(1);
  }
}

.au-hero-overlay{
  position:absolute;
  inset:0;

  background:
    linear-gradient(
  108deg,
  rgba(8,18,12,.90) 0%,
  rgba(13,43,33,.68) 50%,
  rgba(13,43,33,.38) 100%
);
}

/* GRID */

.au-hero-grid{
  position:absolute;
  inset:0;

  background-image:
    linear-gradient(rgba(139,174,102,.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(139,174,102,.08) 1px, transparent 1px);

  background-size:60px 60px;

  pointer-events:none;
}

/* BOTTOM FADE */

.au-hero::after{
  content:'';

  position:absolute;

  bottom:0;
  left:0;
  right:0;

  height:55px;

  background:
    linear-gradient(
      to bottom,
      transparent,
      #ffffff
    );

  z-index:3;
}

/* CONTENT */

.au-hero-content{
  position:relative;

  z-index:2;

  text-align:center;

  color:white;

  padding:0 24px;

  max-width:920px;
  transform: translateY(-40px);
}

/* BADGE */

.au-hero-badge{
  display:inline-flex;
  align-items:center;
  gap:7px;

  background:rgba(139,174,102,.12);
  border:1px solid rgba(139,174,102,.32);

  border-radius:100px;

  font-size:12px;
  font-weight:700;

  letter-spacing:.1em;

  text-transform:uppercase;

  color:var(--brand);

  padding:6px 16px;
  backdrop-filter:blur(8px);
  animation:auFadeUp .6s .1s cubic-bezier(.22,1,.36,1) both;
  margin-bottom:20px;
}

.au-hero-badge-dot{
  width:10px;
  height:10px;

  border-radius:50%;

  background:var(--brand);

  box-shadow:0 0 6px var(--brand);

  animation:auPulse 1.6s ease infinite;
}

@keyframes auPulse{

  0%,100%{
    opacity:1;
    transform:scale(1);
  }

  50%{
    opacity:.5;
    transform:scale(.7);
  }
}

/* HEADING */

.au-hero-h1{
  font-family:var(--ff-display);

  font-size: clamp(2.4rem, 4.5vw, 4.4rem);

  font-weight:800;

  line-height:1;

  letter-spacing:-.03em;

  text-shadow:0 4px 40px rgba(0,0,0,.45);

  margin-bottom:15px;

  animation:auFadeUp .65s .2s cubic-bezier(.22,1,.36,1) both;
}

.au-hero-h1 em{
  font-style:italic;
  color:var(--brand);
}

/* SUBTEXT */

.au-hero-sub{
  font-size:clamp(1rem,1.5vw,1.2rem);

  opacity:.82;

  line-height:1.8;

  max-width:640px;

  margin:0 auto 44px;

  animation:auFadeUp .65s .32s cubic-bezier(.22,1,.36,1) both;
}

/* STATS */

.au-hero-stats{
  display:flex;

  gap:44px;

  justify-content:center;

  flex-wrap:wrap;

  animation:auFadeUp .65s .44s cubic-bezier(.22,1,.36,1) both;
}

.au-hero-stat{
  display:flex;
  flex-direction:column;
  align-items:center;

  gap:4px;
}

.au-hero-stat-val{
  font-family:var(--ff-display);

  font-size:clamp(2rem,3vw,3rem);

  font-weight:800;

  color:var(--brand);

  line-height:1;
}

.au-hero-stat-label{
  font-size:11px;
  font-weight:700;

  letter-spacing:.08em;

  text-transform:uppercase;

  opacity:.62;
}

/* ANIMATION */

@keyframes auFadeUp{

  from{
    opacity:0;
    transform:translateY(24px);
  }

  to{
    opacity:1;
    transform:translateY(0);
  }
}

/* RESPONSIVE */

@media (max-width:768px){

  .au-hero{
    min-height:620px;
    padding:120px 0 90px;
  }

  .au-hero-h1{
    font-size:clamp(2.4rem,10vw,4rem);
    line-height:1.04;
  }

  .au-hero-stats{
    gap:24px;
  }

  .au-hero-sub{
    font-size:15px;
    line-height:1.7;
  }
}

@media (max-width:480px){

  .au-hero-content{
    padding:0 18px;
  }

  .au-hero-h1{
    font-size:2.1rem;
  }

  .au-hero-stats{
    flex-direction:column;
    gap:18px;
  }
}

`}</style>
            <Box
                sx={{
                    background: "#fff",

                }}
            >

                {/* ================= HERO (REFINED BALANCE) ================= */}
                <div className="au-root">

                    <section className="au-hero">

                        <img
                            className="au-hero-img"
                            src={AboutUSBannerImage}
                            alt="Tecniqa HVAC"
                        />

                        <div className="au-hero-overlay" />

                        <div className="au-hero-grid" />

                        <div className="au-hero-content">

                            <div className="au-hero-badge">

                                <div className="au-hero-badge-dot" />

                                About Tecniqa

                            </div>

                            <h1 className="au-hero-h1">

                                Engineering the <em>Future</em>
                                <br />

                                of HVAC & Refrigeration

                            </h1>

                            <p className="au-hero-sub">

                                Delivering certified tools,
                                chemicals, and energy solutions
                                trusted by cooling professionals
                                across India for over 15 years.

                            </p>

                            <div className="au-hero-stats">

                                {STATS.map((s) => (

                                    <div
                                        className="au-hero-stat"
                                        key={s.label}
                                    >

                                        <div className="au-hero-stat-val">
                                            {s.val}
                                        </div>

                                        <div className="au-hero-stat-label">
                                            {s.label}
                                        </div>

                                    </div>

                                ))}

                            </div>

                        </div>

                    </section>

                </div>
                {/* ================= SECTIONS ================= */}

                <Section
                    reverse={false}
                    subtitle="Who We Are"
                    title="Engineering-Driven Industrial Platform"
                    img={aboutImg1}
                    text="Tecniqa is built for industrial professionals who depend on reliable supply chains. We unify HVACR systems, electronic components, and technical tools into a single ecosystem. Every product is carefully evaluated for durability, performance stability, and industrial applicability before listing. This ensures engineers and procurement teams can source confidently, reduce failure risks, and maintain consistent operational efficiency across critical industrial environments."
                />

                <Section
                    reverse={true}
                    subtitle="Mission"
                    title="Bridging Manufacturing & Real-World Demand"
                    img={aboutImg2}
                    text="Our mission is to eliminate inefficiencies in industrial procurement by building a unified, high-trust sourcing ecosystem. We connect manufacturers, engineers, and service teams through a streamlined platform that ensures fast access to verified, high-performance equipment. By reducing sourcing delays and removing quality uncertainty, we help organizations improve operational reliability, accelerate decision-making, and maintain consistent standards across critical industrial workflows."
                />

                <Section
                    reverse={false}
                    subtitle="Core Domain"
                    title="HVACR & Refrigeration Systems"
                    img={aboutImg3}
                    text="We specialize in compressors, condensers, evaporators, cold storage systems, and complete refrigeration infrastructure designed for industrial use. Our solutions are engineered for high-load environments that demand precise thermal stability, optimized energy efficiency, and long operational lifespans. Each system is built to withstand continuous heavy-duty operation while maintaining consistent performance, reliability, and reduced maintenance requirements across critical refrigeration applications."
                />

                <Section
                    reverse={true}
                    subtitle="Expansion"
                    title="Industrial Electronics & Automation"
                    img={aboutImg4}
                    text="Tecniqa extends into PLCs, sensors, VFDs, and embedded control systems that power modern industrial automation and smart manufacturing environments. We bridge traditional mechanical engineering with advanced electronic intelligence, enabling seamless machine control, monitoring, and optimization. Our solutions support Industry 4.0 ecosystems by improving process visibility, operational efficiency, predictive maintenance capabilities, and real-time decision-making across interconnected industrial systems and production infrastructures."
                />

                <Section
                    reverse={false}
                    subtitle="Field Operations"
                    title="Service Tools & Technical Consumables"
                    img={aboutImg5}
                    text="We supply technicians with professional-grade diagnostic and servicing tools, including vacuum pumps, manifold gauges, leak detectors, and complete HVAC maintenance kits. These tools are selected to ensure precise fault detection, efficient system evaluation, and reliable on-site execution. Designed for field conditions, they support accurate diagnostics, reduce downtime, and enable technicians to perform consistent, high-quality maintenance across diverse HVACR and refrigeration systems."
                />

                <Section
                    reverse={true}
                    subtitle="Energy Efficiency"
                    title="Thermal Optimization Solutions"
                    img={aboutImg6}
                    text="Our energy solutions reduce operational cost and improve system efficiency through advanced thermal insulation, refrigerant optimization, and industrial cooling enhancements designed for sustainability-focused operations."
                />

                <Section
                    reverse={false}
                    subtitle="Commitment"
                    title="Quality, Reliability & Technical Trust"
                    img={aboutImg7}
                    text="Every Tecniqa product is backed by strict quality validation and domain expertise. We ensure not just supply, but technical assurance—helping businesses operate with confidence, reduced downtime, and optimized performance."
                />

            </Box>

        </>
    );
}